// extracted by mini-css-extract-plugin
export default {"photo-input":"AppCoverPhoto_photo-input__1foRI","icon":"AppCoverPhoto_icon__cgZI-"};